import { createAction } from 'redux-actions';

const ACTION_PREFIX = '@screen/payment-callback';
const getActionName = (name: string) => `${ACTION_PREFIX}/${name}`;

export const paymentGatewaySuccess = createAction(getActionName('PAYMENT_GATEWAY_SUCCESS'));
export const paymentGatewayFail = createAction(getActionName('PAYMENT_GATEWAY_FAIL'));

export const completePaymentSuccess = createAction(getActionName('COMPLETE_PAYMENT_SUCCESS'));